import 'core-js/es6/map';
import 'core-js/es6/promise';
/** IE10 and IE11 requires the following for the Reflect API. */
import 'core-js/es6/reflect';
import 'core-js/es6/symbol';
import 'core-js/es7/object';
import 'core-js/es7/array';

if (!navigator.sendBeacon) {
    navigator.sendBeacon = function (url, data) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.send(data);
        return true;
    };
}

if (!self.performance) {
    (self as any).performance = {
        timeOrigin: Date.now(),
    };
}
if (!self.performance.now) {
    self.performance.now = function () {
        return Date.now() - self.performance.timeOrigin;
    };
}
